// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__-VakI","alertIcon":"ConfirmModal_alertIcon__3BgHs"};